import React, { useCallback } from 'react';
import { ComplexValue } from 'ui/common/types';
import { SelectedOption } from 'ui/common/select/selected-options/selected-option';
import { AccessLabelProps } from './types';

import styles from './access-label.scss';
import { sortByDescriptionAscending } from 'app/infrastructure/data/sort';

export const AccessLabel: React.FC<AccessLabelProps> = ({ options = [],
  invalidOptions = [],
  onChange, onDelete, readOnly }) => {

  if (options.length === 0) {
    return null;
  }

  const onRemove = useCallback(
    (item: ComplexValue<number>) => {

      const value = options.filter(i => i.value !== item.value);
      onChange(value);

      if(onDelete && options.length === 1) {
        onDelete();
      }
    },
    [options, onChange]
  );

  return <>
    {sortByDescriptionAscending(options).map(
      option => {

        const isValid = readOnly || !invalidOptions.some(invalidOption => option.value === invalidOption.value);

        return (<li key={option.value} className={isValid ? styles.validAccess : styles.invalidAccess}>
          <SelectedOption item={option} onRemove={onRemove} readOnly={readOnly} />
        </li>);
      }
    )}
  </>;
};
